import { render, staticRenderFns } from "./historyCarousel.vue?vue&type=template&id=bea308d4&scoped=true&"
import script from "./historyCarousel.vue?vue&type=script&lang=js&"
export * from "./historyCarousel.vue?vue&type=script&lang=js&"
import style0 from "./historyCarousel.vue?vue&type=style&index=0&id=bea308d4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bea308d4",
  null
  
)

export default component.exports